import Module from '../../core/module';
import Collection from '../../collection';
import Contract from '../../model/contract';
import PickObjects from '../../view/pick.objects';

import { handle } from '../../service/messages';
import { error } from '../../ui/messages'
import { ask, pick, } from '../../utils/popups';
import { eq, hashify } from '../../utils/arrays';
import { beginLock, endLock } from '../../loader';





export default Module.extend( {

    template: 'module/tasks/contracts.form',

    url() {
        return this.model.id
            ? `contracts/${this.model.id}`
            : `contracts/new`;
    },

    open(model) {
        return this.bind( model );
    },

    start() {
        this.listenTo( this.model, 'change',
            () => this.Buttons.render() );
    },

    stop() {
        this.stopListening( this.model );
    },

    diff(options = {}) {
        const diff = this.model.diff( this.originalModel, options );
        if (diff.length > 0)
            return diff;

        const hasDiff = this.model.get( 'groups' ).some( (group, index) => {
            const other = this.originalModel.get( 'groups' )[index];
            const groupObjects = group.objects.map( ({ object_id, ...attrs }) => 
                ({ id: object_id, ...attrs }) );
            const otherObjects = other.objects.map( ({ object_id, ...attrs }) => 
                ({ id: object_id, ...attrs }) );

            return !eq( groupObjects, otherObjects )
                || !eq( group.types, other.types );
        } );

        if (hasDiff)
            return [{
                attrName: 'groups',
                oldValue: this.originalModel.get( 'groups' ),
                newValue: this.model.get( 'groups' ),
            }];

        return [];
    },

    serialize() {
        const { datatables, organizations, } = this.options;

        return { 
            datatables, organizations,
            groups: this.model.get( 'groups' ),
         };
    },

    events: {

        'click .-edit-objects'({ currentTarget }) {
            const $group = this.$( currentTarget ).closest( '.contract-group' );
            const groupIndex = +$group.attr( 'name' );
            const group = this.model.get( 'groups' )[groupIndex]; 
            pickObjects( group, this.options.datatables )
                .then( () => (this[groupIndex].render(), this.Buttons.render() ) ); // todo focus?
        },

        'click .-edit-types'({ currentTarget }) {
            const clusters = hashify( this.options.clusters, cluster => [cluster.id, cluster] );
            const orgs = hashify( this.options.organizations, org => [org.id, org] );
            const org = this.model.get( 'assigned_organization' ) ||
                this.model.get( 'customer' );

            const $group = this.$( currentTarget ).closest( '.contract-group' );
            const groupIndex = +$group.attr( 'name' );
            const group = this.model.get( 'groups' )[groupIndex]; 

            pick( group.types,  
                { collection: this.options.types, 
                    clusters: this.options.clusters, 
                    cluster: org && clusters[orgs[org.id].cluster_id],
                    idOnly: false, fullCollection: true } )
                // skip earlier deleted types
                .then( newTypes => newTypes.filter( t => !!t ) )
                .then( newTypes => group.types = newTypes )
                .then( () => (this[groupIndex].render(), this.Buttons.render() ) ); // todo focus?
        },

        'click .-add-group'() {
            const groups = this.model.get( 'groups' );
            this.model.set( 'groups', [...groups, {
                objects: [],
                types: [],
            }] );

            return this.render();
        },

        'click .-remove-group'({ currentTarget }) {
            const $group = this.$( currentTarget ).closest( '.contract-group' );
            const groupIndex = +$group.attr( 'name' );
            
            const groups = this.model.get( 'groups' )
                .filter( (group, index) => index != groupIndex );
            this.model.set( 'groups', groups );

            return this.render();
        },

        'click .-close'() {
            this.trigger( Module.BACK );
        },

        'click .-save'() {
            const {
                groups, types, ...otherAttrs
            } = this.model.toJSON();

            const oldGroups = hashify( this.originalModel.get( 'groups' ),
                g => [g.id, g] );
            const newGroupIds = hashify( this.model.get( 'groups' )
                .map( g => g.id ).filter( id => id ) );
            const groups_add = this.model.get( 'groups' )
                .filter( g => !g.id )
                .map( ({ types, objects, ...otherAttrs }) => ({
                    types_add: types,
                    objects_add: objects,
                    ...otherAttrs,
                }) );
            const groups_remove = this.originalModel.get( 'groups' )
                .filter( g => !newGroupIds[g.id] );
            // todo groups_remove
            const groups_edit = this.model.get( 'groups' )
                .filter( g => g.id )
                .map( ({ id, types, objects, ...attrs }) => {
                    const oldGroup = oldGroups[id];

                    const oldTypeIds = hashify( oldGroup.types, type => [type.id, true] );
                    const newTypeIds = hashify( types, type => [type.id, true] );

                    const types_add = types.filter( type => !oldTypeIds[type.id] );
                    const types_remove = oldGroup.types.filter( type => !newTypeIds[type.id] )

                    const oldObjectIds = hashify( oldGroup.objects, 
                        object => [`${object.layer_id}/${object.object_id}`, true] );
                    const newObjectIds = hashify( objects, 
                        object => [`${object.layer_id}/${object.object_id}`, true] );
    
                    const objects_add = objects.filter( 
                        object => !oldObjectIds[`${object.layer_id}/${object.object_id}`] );
                    const objects_remove = oldGroup.objects.filter( 
                        object => !newObjectIds[`${object.layer_id}/${object.object_id}`] );
                        
                    return {
                        id,
                        types_add, types_remove,
                        objects_add, objects_remove,
                        ...attrs,
                    }
                } );

            const json = {
                groups_add,
                groups_edit,
                groups_remove,
                ...otherAttrs,
            };

            const onResolve = savedModel => { 
                this.options.contracts.add( savedModel, { merge: true } );
                this.trigger( Module.BACK );
            };

            const onReject =  message => {
                endLock( this );
                handle( this.Fields, error( message ) );
            };

            beginLock( this );
            return new Contract( { id: this.model.id } ).patch( json )
                .then( response => new Contract( response ) )
                .then( onResolve, onReject );
        },

    },

}, {

    OPEN: 'open-contract',

} );





function pickObjects(group, datatables) {
    const view = PickObjects.of( { 
        datatables: new Collection( datatables
            .toJSON()
            .filter( layer => layer.access.serviceObjects ) )
    } );

    const binding = view.bind( { selected: group.objects } );

    return ask( binding, 'popups::pick - title', 'actions::apply', 'actions::cancel',
        { large: true } )
        .then( () => view.model.get( 'selected' ) )
        .then( objects => group.objects = objects ); 
}



// WEBPACK FOOTER //
// ./src/js/module/tasks/contracts.form.js